import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      borderRadius: '10px',
      overflow: 'hidden',
    },
    detailRow: {
      marginBottom: 20,
    },
    matchTitle: {
      color: '#151528',
      fontSize: 20,
      fontFamily: 'ITC Avant Garde Gothic Std Bold',
      marginLeft: 20,
    },
    title: {
      fontFamily: 'Open Sans',
      fontWeight: 700,
      fontSize: 16,
      color: '#000A8C',
    },
    mainTitle: {
      fontFamily: 'Open Sans',
      fontWeight: 700,
      color: '#000A8C',
      fontSize: 26,
      lineHeight: '100%',
      textTransform: 'none',
      marginBottom: 10,
    },
    cardContainer: {
      padding: 40,
      borderRadius: 5,
      background: 'white',
      borderWidth: 2,
    },
    content: {
      color: '#000000',
      fontFamilly: 'Poppins',
      fontSize: 16,
      fontWeight: 500,
    },
    chip: {
      backgroundColor: '#B0B5FF',
      color: '#151528',
      borderRadius: 5,
      marginRight: 10,
      fontSize: 14,
      paddingTop: 5,
    },
  })
)